import { render, staticRenderFns } from "./ModalRegionSinNumerar.vue?vue&type=template&id=5626c69a"
import script from "./ModalRegionSinNumerar.vue?vue&type=script&lang=js"
export * from "./ModalRegionSinNumerar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports